import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Select, Tabs } from 'antd';
import { ArrowDown2 } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import TextArea from 'antd/es/input/TextArea';
import http from '../../../../../security/Http';
import url from '../../../../../Development.json';
import authStores from '../../../../contexs/AuthProvider';
import { linesToText, textToLines } from '../../../../utils/symptomManual';

const { Option } = Select;

const emptyManual = () => ({
  observation: '',
  emergancyTransport: '',
  response: '',
});

function SymptomManual() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = localStorage.getItem('i18nextLng');
  const Token = localStorage.getItem('token');
  const authstore = authStores();
  const parsedAuth = JSON.parse(localStorage.getItem('auth-storage'));
  const userRole = authstore?.role || parsedAuth?.state?.role;
  const isAdmin = userRole === 'superAdmin';
  const [symptoms, setSymptoms] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [jaManual, setJaManual] = useState(emptyManual());
  const [enManual, setEnManual] = useState(emptyManual());
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!isAdmin) {
      navigate('/');
    }
  }, [isAdmin]);

  const loadSymptoms = () => {
    setIsLoading(true);
    http
      .get(process.env.REACT_APP_BASE_URL + `/admin/symptoms`, { _: Date.now() }, {
        headers: { authorization: 'Bearer ' + Token, lang, 'Cache-Control': 'no-cache' },
      })
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setSymptoms(list);
        setIsLoading(false);
      })
      .catch(() => {
        setSymptoms([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (isAdmin) {
      loadSymptoms();
    }
  }, []);

  const handleSymptomChange = (id) => {
    setSelectedId(id);
    const symptom = symptoms.find((s) => s._id === id);
    if (!symptom) {
      setJaManual(emptyManual());
      setEnManual(emptyManual());
      return;
    }
    setJaManual({
      observation: linesToText(symptom?.manual?.ja?.observation),
      emergancyTransport: linesToText(symptom?.manual?.ja?.emergancyTransport),
      response: linesToText(symptom?.manual?.ja?.response),
    });
    setEnManual({
      observation: linesToText(symptom?.manual?.en?.observation),
      emergancyTransport: linesToText(symptom?.manual?.en?.emergancyTransport),
      response: linesToText(symptom?.manual?.en?.response),
    });
  };

  const handleSave = () => {
    if (!selectedId) {
      enqueueSnackbar(t('Manual.Select_Symptom'), { variant: 'warning' });
      return;
    }
    setIsSaving(true);
    const payload = {
      id: selectedId,
      manual: {
        ja: {
          observation: textToLines(jaManual.observation),
          emergancyTransport: textToLines(jaManual.emergancyTransport),
          response: textToLines(jaManual.response),
        },
        en: {
          observation: textToLines(enManual.observation),
          emergancyTransport: textToLines(enManual.emergancyTransport),
          response: textToLines(enManual.response),
        },
      },
    };

    http
      .callApi(url.updateSymptomManual, payload, {
        headers: { authorization: 'Bearer ' + Token, lang },
      })
      .then((res) => {
        enqueueSnackbar(res.data?.message || t('Manual.Save_Success'), { variant: 'success' });
        http
          .get(process.env.REACT_APP_BASE_URL + `/admin/symptoms`, { _: Date.now() }, {
            headers: { authorization: 'Bearer ' + Token, lang, 'Cache-Control': 'no-cache' },
          })
          .then((refreshRes) => {
            const list = Array.isArray(refreshRes.data) ? refreshRes.data : [];
            setSymptoms(list);
            const symptom = list.find((s) => s._id === selectedId);
            if (symptom) {
              setJaManual({
                observation: linesToText(symptom?.manual?.ja?.observation),
                emergancyTransport: linesToText(symptom?.manual?.ja?.emergancyTransport),
                response: linesToText(symptom?.manual?.ja?.response),
              });
              setEnManual({
                observation: linesToText(symptom?.manual?.en?.observation),
                emergancyTransport: linesToText(symptom?.manual?.en?.emergancyTransport),
                response: linesToText(symptom?.manual?.en?.response),
              });
            }
            setIsSaving(false);
          })
          .catch(() => setIsSaving(false));
      })
      .catch((error) => {
        enqueueSnackbar(
          error.response?.data?.message || t('Manual.Save_Failed'),
          { variant: 'error' }
        );
        setIsSaving(false);
      });
  };

  const renderFields = (manual, setManual, labels) => (
    <>
      <Form.Item label={labels.observation} className="mb20">
        <TextArea
          rows={8}
          value={manual.observation}
          onChange={(e) => setManual({ ...manual, observation: e.target.value })}
        />
      </Form.Item>
      <Form.Item label={labels.emergancyTransport} className="mb20">
        <TextArea
          rows={6}
          value={manual.emergancyTransport}
          onChange={(e) => setManual({ ...manual, emergancyTransport: e.target.value })}
        />
      </Form.Item>
      <Form.Item label={labels.response} className="mb20">
        <TextArea
          rows={10}
          value={manual.response}
          onChange={(e) => setManual({ ...manual, response: e.target.value })}
        />
      </Form.Item>
    </>
  );

  const labelsJa = {
    observation: '観察・確認事項',
    emergancyTransport: '緊急搬送',
    response: '対応',
  };
  const labelsEn = {
    observation: 'Observation/Confirmation',
    emergancyTransport: 'Emergency transport',
    response: 'Response',
  };

  if (!isAdmin) {
    return null;
  }

  return (
    <section className="ptb40">
      <div className="custom_card mb30">
        <div className="custom_card_head flex_item_cb flex-wrap mb16">
          <h4>{t('Manual.Title')}</h4>
        </div>
        <div className="custom_card_body">
          <Form layout="vertical">
          <Row gutter={16}>
            <Col sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item label={t('Reports.Project_Type')}>
                <Select
                  className="custom-ant-select"
                  placeholder={t('Reports.Project_Type')}
                  value={selectedId}
                  onChange={handleSymptomChange}
                  loading={isLoading}
                  suffixIcon={<ArrowDown2 size="18" color="#707070" variant="Bold" />}
                >
                  {symptoms.map((s) => (
                    <Option key={s._id} value={s._id}>
                      {lang === 'en' ? s.ename : s.jname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {selectedId ? (
            <Tabs
              defaultActiveKey="ja"
              items={[
                {
                  key: 'ja',
                  label: '日本語',
                  children: renderFields(jaManual, setJaManual, labelsJa),
                },
                {
                  key: 'en',
                  label: 'English',
                  children: renderFields(enManual, setEnManual, labelsEn),
                },
              ]}
            />
          ) : (
            <p className="text-gray">{t('Manual.Select_Symptom')}</p>
          )}
          </Form>

          <div className="flex_item_ce gap2 mt20">
            <Button
              type="primary"
              className="btn btn-primary"
              onClick={handleSave}
              loading={isSaving}
              disabled={!selectedId}
            >
              {t('Manual.Save')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SymptomManual;
